module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Michal_Zuzanna.cd7026ac.jpg";